module.exports = __webpack_public_path__ + "img/11_29.2be627c6.png";